<template>
    <div>
        <div class="sm:grid sm:grid-cols-3 sm:gap-4 sm:items-start sm:pt-2">
          <label class="block text-sm font-medium text-gray-700 sm:mt-px sm:pt-2">
            {{label}}
          </label>
          <div class="text-gray-700 text-sm pt-2 mt-1 sm:mt-0 sm:col-span-2">
            <div class="max-w-lg block w-full sm:max-w-xs sm:text-sm rounded-md">
              <slot/>
            </div>
          </div>
        </div>
    </div>
</template>

<script>

export default {
    components: {
    },
    computed: {
    },
    props: [
        'label',
    ]
};
</script>